import React from 'react'
import { Layout, Header, Intro } from '../../../../components'

import data from './data.json'
import './style.scss'
import Changelog from './changelog'

export default () => {
  return (
    <>
      <Header
        slug={data.slug + '/design/'}
        site={data.site}
        state="design"
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
        complete={true}
      >
        <Intro>
          <p>
            All changes and revisions to Wilmington Trust Currency will be
            documented here. For specific questions or issues with updating,{' '}
            <a class="link" href="mailto:currencydesignsytem@mtb.com">
              please reach out to us
            </a>
            .
          </p>
        </Intro>
        <Changelog></Changelog>
      </Layout>
    </>
  )
}
